<template>
    <div class="body">
      <div class="header">
        <el-form :model="accountForm" :inline="true">
          <el-form-item>
            <el-button class="btn-style btn-redownload" type="primary" @click="tohandleEdit">编辑</el-button>
          </el-form-item>
        </el-form>
        <div style="display: flex">
          <el-upload
            class="upload-demo"
            action="#"
            accept="xlsx,xls"
            multiple
            :limit="1"
            :auto-upload="false"
            :with-credentials="false"
            :show-file-list="false"
          >
          <!-- <el-button size="small" type="primary">导入</el-button> -->
          </el-upload>
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
   
          <el-table-column
            prop="singlelineNumber"
            align="center"
            label="面板走单线编号"
          ></el-table-column>
          <el-table-column
            prop="grooveNumber"
            align="center"
            label="面板铣槽编号"
          ></el-table-column>
        
          <el-table-column
            prop="nonMillingNumber"
            align="center"
            label="底板不铣区编号"
          ></el-table-column>
          <el-table-column
            prop="boreNumber"
            align="center"
            label="面板打孔编号"
          ></el-table-column>
          <el-table-column
            prop="hypotenuseNumber"
            align="center"
            label="斜边内嵌底板编号"
          ></el-table-column>
          <el-table-column
            prop="edgeEmbeddedNumber"
            align="center"
            label="直边内嵌底板编号"
          ></el-table-column>
          <el-table-column
            prop="edgeMiniNumber"
            align="center"
            label="直边迷你字编号"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="设置时间"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>


      <password ></password>

      <el-dialog title="编辑特殊工艺设置" :visible.sync="dialogVisible"  
                 text-align="center"
                :close-on-click-modal="false"
                class="order-dialog"
                width="75%"
                center>
        <el-form
        ref="accountForm"
                    :model="accountForm"
                    class="demo-accountForm form-style"
        >
        <div class="accountForm-header">
            <el-divider> <h1  class="drspen">面板走单线</h1></el-divider>
          <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="面板走单线编号" prop="outreachValue">
            <el-input v-model="accountForm.singlelineNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板走单线转速" prop="outreachValue">
            <el-input v-model="accountForm.singlelineSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板走单线进给量" prop="outreachValue">
            <el-input v-model="accountForm.singlelineLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="面板走单线下刀z值" prop="outreachValue">
            <el-input v-model="accountForm.singlelineCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板走单线抬刀z值" prop="outreachValue">
            <el-input v-model="accountForm.singlelineKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板走单线直径" prop="outreachValue">
            <el-input v-model="accountForm.singlelineDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
    <el-divider> <h1  class="drspen">面板铣槽</h1></el-divider>
    <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="面板铣槽编号" prop="outreachValue">
            <el-input v-model="accountForm.grooveNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板铣槽转速" prop="outreachValue">
            <el-input v-model="accountForm.grooveSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板铣槽进给量" prop="outreachValue">
            <el-input v-model="accountForm.grooveLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="面板铣槽下刀z值" prop="outreachValue">
            <el-input v-model="accountForm.grooveCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板铣槽抬刀z值" prop="outreachValue">
            <el-input v-model="accountForm.grooveKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板铣槽直径" prop="outreachValue">
            <el-input v-model="accountForm.grooveDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-divider> <h1  class="drspen">底板不铣区</h1></el-divider>
    <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="底板不铣区编号" prop="outreachValue">
            <el-input v-model="accountForm.nonMillingNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="底板不铣区转速" prop="outreachValue">
            <el-input v-model="accountForm.nonMillingSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="底板不铣区进给量" prop="outreachValue">
            <el-input v-model="accountForm.nonMillingLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="底板不铣区下刀z值" prop="outreachValue">
            <el-input v-model="accountForm.nonMillingCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="底板不铣区抬刀z值" prop="outreachValue">
            <el-input v-model="accountForm.nonMillingKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="底板不铣区直径" prop="outreachValue">
            <el-input v-model="accountForm.nonMillingDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-divider> <h1  class="drspen">面板打孔</h1></el-divider>
    <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="面板打孔编号" prop="outreachValue">
            <el-input v-model="accountForm.boreNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板打孔转速" prop="outreachValue">
            <el-input v-model="accountForm.boreSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板打孔进给量" prop="outreachValue">
            <el-input v-model="accountForm.boreLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="面板打孔下刀z值" prop="outreachValue">
            <el-input v-model="accountForm.boreCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板打孔抬刀z值" prop="outreachValue">
            <el-input v-model="accountForm.boreKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="面板打孔直径" prop="outreachValue">
            <el-input v-model="accountForm.boreDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>

        <el-divider> <h1  class="drspen">斜边内嵌底板</h1></el-divider>
    <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="斜边内嵌底板编号" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="斜边内嵌底板转速" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="斜边内嵌底板进给量" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="斜边内嵌底板下刀z值" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="斜边内嵌底板抬刀z值" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="斜边内嵌底板直径" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="斜边内嵌卡槽宽度" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseWidth" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="斜边内嵌卡槽深度" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseDepth" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="斜边内嵌底板卡槽厚度" prop="outreachValue">
            <el-input v-model="accountForm.hypotenuseThickness" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
          
        <el-divider> <h1  class="drspen">直边内嵌底板</h1></el-divider>
    <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="直边内嵌底板编号" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边内嵌底板转速" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边内嵌底板进给量" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="直边内嵌底板下刀z值" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边内嵌底板抬刀z值" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边内嵌底板直径" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="直边内嵌卡槽宽度" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedWidth" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边内嵌卡槽深度" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedDepth" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边内嵌底板卡槽厚度" prop="outreachValue">
            <el-input v-model="accountForm.edgeEmbeddedThickness" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
          
        <el-divider> <h1  class="drspen">直边迷你字</h1></el-divider>
    <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="直边迷你字编号" prop="outreachValue">
            <el-input v-model="accountForm.edgeMiniNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边迷你字转速" prop="outreachValue">
            <el-input v-model="accountForm.edgeMiniSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边迷你字进给量" prop="outreachValue">
            <el-input v-model="accountForm.edgeMiniLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="直边迷你字下刀z值" prop="outreachValue">
            <el-input v-model="accountForm.edgeMiniCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边迷你字抬刀z值" prop="outreachValue">
            <el-input v-model="accountForm.edgeMiniKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item label="直边迷你字直径" prop="outreachValue">
            <el-input v-model="accountForm.edgeMiniDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="直边迷你字卡槽厚度" prop="outreachValue">
            <el-input v-model="accountForm.edgeMiniThickness" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
      
        </el-row>
        </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import password from '@/components/password.vue';
  import {selectSpecialSet,addSpecialSet} from '@/api/set/process'
  export default {
    components: {
      password
  },
    data() {
      return {
      direction: 'rtl',
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        drawer: false,
        access: '',
        date: '',
        dialogVisible: false,
        conTract: [],
        copyMode:["切边定位(东阳)","两孔定位(圣吴)","对称孔定位(梵匠)","钻孔定位(华卓)","固定孔定位(风驰)","靠尺定位"],
        machineType:[{
        value: '0',
        label: '横版'
      }, {
        value: '1',
        label: '竖版'
      }, {
        value: '1',
        label: '横版和竖版'
      }],
      directionStatus:[{
        value: '0',
        label: '顺时针'
      }, {
        value: '1',
        label: '逆时针'
      }],
        accountForm: {
            singlelineNumber:'',
            singlelineSpeed:'',
            singlelineLoad: '',
            singlelineCutz: '',
            singlelineKnifez:'',
            singlelineDiameter:'',
    
            grooveNumber: '',
            grooveSpeed:'',
            grooveLoad: '',
            grooveCutz:'',
            grooveKnifez:'',
            grooveDiameter:'',
    
            nonMillingNumber: '',
            nonMillingSpeed:'',
            nonMillingLoad: '',
            nonMillingCutz:'',
            nonMillingKnifez:'',
            nonMillingDiameter:'',

            boreNumber: '',
            boreSpeed:'',
            boreLoad: '',
            boreCutz:'',
            boreKnifez:'',
            boreDiameter:'',
 
            hypotenuseNumber:'',
            hypotenuseSpeed:'',
            hypotenuseLoad:'',
            hypotenuseCutz:'',
            hypotenuseKnifez:'',
            hypotenuseDiameter:'',
            hypotenuseWidth:'',
            hypotenuseDepth:'',
            hypotenuseThickness:'',

          edgeEmbeddedNumber:'',
          edgeEmbeddedSpeed:'',
          edgeEmbeddedLoad:'',
          edgeEmbeddedCutz:'',
          edgeEmbeddedKnifez:'',
          edgeEmbeddedDiameter:'',
          edgeEmbeddedWidth:'',
          edgeEmbeddedDepth:'',
          edgeEmbeddedThickness:'',

          edgeMiniNumber:'',
          edgeMiniSpeed:'',
          edgeMiniLoad:'',
          edgeMiniCutz:'',
          edgeMiniKnifez:'',
          edgeMiniDiameter:'',
          edgeMiniThickness:'',
     
          id:'',
          access:''
        },
        ImpositionFileDTO:{
            startTime: '',
            endTime: '',
            status: '2'
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
        }
      }
    },
    
  
    mounted() {
      this.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.dialogVisible = true
      },
      getTableData() {
        selectSpecialSet(this.access).then((res) => {
          this.conTract = res.data.data
        //  this.total = Number(res.data.data.total)
        })
      },
      handleEdit(row) {
        this.dialogVisible = true
        if(row){
          this.accountForm=row;
        }
       
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addCarving(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
      //修改
      editAccount() {
        addSpecialSet(this.accountForm).then((res) => {
          if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
            this.dialogVisible = false
          } else if (res.data.msg !== '操作成功') {
            this.$message({
                type: 'info',
                message: res.data.data
              })
          }
          this.getTableData()
        }
        )
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.ImpositionFileDTO.startTime = e[0]
          this.ImpositionFileDTO.endTime = e[1]
        } else if (!e) {
          this.ImpositionFileDTO.startTime = ''
          this.ImpositionFileDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
  
    
    }
  }
  </script>
  
  <style lang="scss" scoped>
  
  .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin: 20px;
  }
  
  .body {
      overflow: auto;
  }
  
  .pagination {
      margin-top: 10px;
      margin-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: relative;
  }
  
  .el-pagination ::v-deep.el-pagination__total {
      line-height: 36px;
  }
  
  .el-table .warning-row {
      background: oldlace;
  }
  
  .el-table .success-row {
      background: #f0f9eb;
  }
  .goodsTableData{
      margin: 20px 0 ;
  }
  .btn-style{
      min-width: 72px;
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-buy{
      background: #FF8429;
  }
  .btn-print{
      background: #4093FF;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  .btn-view{
      background: var(--theme-color);
  }
  .product-form .el-form-item{
      margin-bottom: 0;
  }
  .table-content{
      margin: 20px;
  }
  .check-all{
      color: #333;
      font-size: 16px;
      margin-right: 20px;
      cursor: pointer;
  }
  .el-pagination{
      margin: 0;
  }
  
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  
  .drspen{
    font-family: "Algerian";
            color: rgb(139, 0, 12);
  }
  .table-value{
      color: var(--color);
  }
  .table-info{
      width: 80%;
      justify-content: space-between;
  }
  .table-info > p{
      display: inline-block;
      width: 150px;
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-shrink: 0;
  }
  
  .table-item{
      background: #F7F7F7;
      margin: 8px 0;
      border-radius: 12px;
      padding: 12px;
  }
  .table-image{
      width: 100px;
      height: 50px;
      margin-right: 20px;
  }
  ::v-deep.table-image .image-slot{
      height: 50px;
      display: flex;
      align-items: center;
  }
  ::v-deep.table-image .image-slot i{
      font-size: 50px;
  }
  .pay{
      color:var(--theme-color);
  }
  .no-pay{
      color:#FF4D4D;
  }
  .btn-group{
      display: flex;
      flex-direction: column;
      gap: 10px;
  }
  .btn-group .el-button{
      border-radius: 20px;
      width: 76px;
  }
  .btn-collection{
      background: #F9DDDD;
  }
  .btn-view-detail{
      background: #D3F2E4;
      color: var(--theme-color);
  }
  .el-divider--vertical {
  display: inline-block;
  weight: 1px;
  height: 70%;
  margin: 0 8px;
  background: 0 0;
  border-left: 2px dashed #e8eaec;
  position: relative;
}

  .btn-reckon{
      background: rgb(245, 233, 212);
    
  }
  
  ::v-deep.order-dialog .el-dialog{
      border-radius: 24px;
  }
  .operator label{
      letter-spacing: 5px;
  }
  ::v-deep.dialog-upload{
      display: flex;
  }
  ::v-deep.dialog-upload .el-form-item__label{
      flex-shrink: 0;
  }
  ::v-deep.dialog-upload .el-form-item__content{
      justify-content: right;
  }
  ::v-deep.dialog-upload .avatar-uploader{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #D8E0DD;
  }
  ::v-deep.dialog-upload .el-upload--text{
      width: 100%;
      height: 100%;
  }
  ::v-deep.dialog-upload img{
      max-width: 100px;
  }
  .accountForm-header{
      background: #F7F7F7;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 20px;
  }
  .btn-add{
      background: #FF8429;
      border-radius: 8px;
  }
  .form-submit{
      background: var(--theme-color);
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .table-no-pay{
      background: #ffeded;
  }
  
  ::v-deep.el-icon-remove-outline{
      font-size: 32px;
      color: #a3d8f9cc;
  }

  
  </style>
  